document.addEventListener("DOMContentLoaded", function () {
  /*** product-swtch */
    const variantAlt = document.querySelector(".product-form__input--pill input[type='radio']:checked")?.value;
    console.log(variantAlt,"--variantAlt");
    setTimeout(function(){
        var count_list = Array.from(document.querySelectorAll('.product-m2'))
        .filter(el => getComputedStyle(el).display === 'block')
        .length;
        var count_list = parseInt(count_list) + 1;
        console.log(count_list);
      const sliderItems = document.querySelectorAll('.slider-counter__link');
      // Hide all first
      sliderItems.forEach(item => {
        item.style.display = 'none';
      });
      // Show only first "count" items
      for (let i = 0; i < count_list && i < sliderItems.length; i++) {
        sliderItems[i].style.display = 'block';
      }
    }, 1000);

    document.querySelectorAll('.product-m2').forEach(el => {
      el.style.display = 'none';
    });

    document.querySelectorAll(`.product-m2[data-variants='${variantAlt}']`)
      .forEach(el => {
        el.style.display = 'block';
      });

        document.querySelectorAll('.thumb-list2').forEach(el => {
      el.style.display = 'none';
    });

    document.querySelectorAll(`.thumb-list2[data-variants='${variantAlt}']`)
      .forEach(el => {
        el.style.display = 'block';
      });
    /*** end product-swatch */

    const p = document.querySelector('.p_custom_type');
    const r = document.querySelector('.rating-wrapper');
    if (p && r) {
      const wrap = document.createElement('div');
      wrap.className = 'rt_custom_wrap';
      p.parentNode.insertBefore(wrap, p);
      wrap.appendChild(p);
      wrap.appendChild(r);
    }
    // ---------------- Elements ----------------
    const stickyBtn = document.querySelector(".sticky-form__submit");
    const soldOutBtn = document.querySelector(".sold_out_btn");
    const qtyWrapper = document.querySelector(".quantity-selector");
    const plusBtn = document.querySelector(".quantity-selector .plus");
    const minusBtn = document.querySelector(".quantity-selector .minus");
    const stickyInputQty = document.querySelector(".sticky_quantity");
    const stickyVariantInput = document.querySelector(".sticky_prd_id");

    // ---------------- Helper ----------------
    const getSelectedVariantId = () => {
      return stickyVariantInput && stickyVariantInput.value
        ? parseInt(stickyVariantInput.value, 10)
        : null;
    };

    // ---------------- Update UI based on cart & availability ----------------
    async function updateStickySection(variant) {
      if (!variant) return;

      // Update hidden input
      if (stickyVariantInput) stickyVariantInput.value = variant.id;

      // Fetch cart
      let itemInCart = null;
      try {
        const res = await fetch("/cart.js");
        const cart = await res.json();
        itemInCart = cart.items.find(item => Number(item.id) === Number(variant.id));
      } catch (err) {
        console.error("Error fetching cart:", err);
      }

      // Decide UI
      if (itemInCart) {
        // Variant in cart → show quantity, hide buttons
        if (qtyWrapper) qtyWrapper.style.display = "flex";
        if (stickyInputQty) stickyInputQty.value = itemInCart.quantity;
        if (stickyBtn) stickyBtn.style.display = "none";
        if (soldOutBtn) soldOutBtn.style.display = "none";
      } else if (variant.available) {
        // Not in cart, available → show Add
        if (qtyWrapper) qtyWrapper.style.display = "none";
        if (stickyBtn) stickyBtn.style.display = "flex";
        if (soldOutBtn) soldOutBtn.style.display = "none";
        if (stickyInputQty) stickyInputQty.value = 1;
      } else {
        // Not in cart, unavailable → show Sold Out
        if (qtyWrapper) qtyWrapper.style.display = "none";
        if (stickyBtn) stickyBtn.style.display = "none";
        if (soldOutBtn) soldOutBtn.style.display = "flex";
        if (stickyInputQty) stickyInputQty.value = 1;
      }
    }

  // ---------------- Add to cart ----------------
    if (stickyBtn) {
      stickyBtn.addEventListener("click", () => {
        const mainBtn = document.querySelector(".product-form__submit[name='add']");
        if (mainBtn) mainBtn.click();
        setTimeout(() => {
          const variant = {
            id: getSelectedVariantId(),
            available: true, // assume available after adding
          };
          updateStickySection(variant);
        }, 1000);
      });
    }

  // ---------------- Plus button ----------------
    if (plusBtn) {
      plusBtn.addEventListener("click", () => {
        const mainBtn = document.querySelector(".product-form__submit[name='add']");
        if (mainBtn) mainBtn.click();
        if (stickyInputQty) stickyInputQty.value = parseInt(stickyInputQty.value) + 1;
        setTimeout(() => {
          const variant = {
            id: getSelectedVariantId(),
            available: true,
          };
          updateStickySection(variant);
        }, 1000);
      });
    }

  // ---------------- Minus button (optional) ----------------
  if (minusBtn) {
    minusBtn.addEventListener("click", async () => {
      if (!stickyInputQty) return;
      const qty = parseInt(stickyInputQty.value, 10);

      try {
        // Fetch the cart
        
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();

        // Find the cart item matching the current variant
        const cartItem = cart.items.find(item => Number(item.variant_id) === getSelectedVariantId());
        if (!cartItem) return; // nothing to remove

        // Decide new quantity
        const newQty = qty > 1 ? qty - 1 : 0;

        // Update cart using item key
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: cartItem.key, // 🔑 use the cart item's key, not variant ID
            quantity: newQty
          })
        });
        
        // Refresh cart UI and sticky section
         // or window.refreshCart()
        

        updateStickySection({
          id: cartItem.variant_id,
          available: stickyVariantInput.dataset.available === "true"
        });
         window.updateCartTotal();
         
         // cart update       
        fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(res => res.json())
        .then(data => {

          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            const temp = document.createElement('div');
            temp.innerHTML = data['cart-drawer'];

            // ✅ Sirf inner content replace karo
            const newContent = temp.querySelector('.drawer__inner');
            const currentContent = drawer.querySelector('.drawer__inner');

            if (newContent && currentContent) {
              currentContent.innerHTML = newContent.innerHTML;
            }
          }

          const bubble = document.querySelector('#cart-icon-bubble');
          if (bubble) {
            bubble.innerHTML = data['cart-icon-bubble'];
          }
        });
        //  if (typeof window.progress_gifts === "function") {
        //   window.progress_gifts();
        // }
      
      } catch (err) {
        console.error("Cart change error:", err);
      }
    });
  }

  // ---------------- Initialize on page load ----------------
  if (stickyVariantInput && stickyVariantInput.value) {
    const variant = {
      id: parseInt(stickyVariantInput.value, 10),
      available: stickyVariantInput.dataset.available === "true", // read from data-attribute if available
    };
    updateStickySection(variant);
  }

  // Expose globally if needed
  window.updateStickySection = updateStickySection;
});

// Using product sticky JS
// window.addEventListener('scroll', function() {
//     const stickyCart = document.querySelector('.sticky-add-to-cart');
//     const target = document.querySelector('.wrap_mobile_div');
//     if (!stickyCart || !target) return;
//     const targetBottom = target.getBoundingClientRect().bottom + window.scrollY;
//     if (window.scrollY > targetBottom) {
//          document.querySelector('body').classList.add("threshould_sticky");
//         stickyCart.style.display = 'block'; // or add a class for fadeIn
//     } else {
//        document.querySelector('body').classList.remove("threshould_sticky");
//         stickyCart.style.display = 'none'; // or remove the class
//     }
// });

document.querySelectorAll('.product__info-wrapper .rating-text-custom').forEach(el => {
  el.addEventListener('click', function () {
    document.querySelector('#judgeme_product_reviews').scrollIntoView({
      behavior: 'smooth'
    });
  });
});